import Rt, { memo as Te, useState as Y, useCallback as q, useContext as Z, useReducer as et, useEffect as V, useMemo as G, createElement as ns, createContext as as } from "react";
import { Grid as y, Block as Se, Input as Ae, Select as je, Button as B, Icon as D, Spinner as W, useNotifications as ve, AnalysisIcon as ze, Typography as Ee, Checkbox as is, Autocomplete as rs, Paper as jt, Box as ge, Tooltip as tt, IconButton as At, useTheme as os, Divider as st, NewTable as vt, FilterPanel as ls, Modal as Ve, ContentBlock as cs } from "@prometheus/components";
import { FormElement as ee, FormActionsContainer as nt, SubModuleDescriptionBlock as us, ICON_COLUMN as ds, ID_COLUMN as ps, NAME_COLUMN as ms, CREATED_COLUMN as ys, UPDATED_COLUMN as xs, AUTHOR_COLUMN as hs, SpinnerWidgetContainer as fe, CodeEditor as _t, FileContentType as Es, PageList as Ss, ImportMultipleSource as gs, TabWithCounter as He, FloatingBlock as Cs, DataSourceLogo as Ts, DataSourceLabel as fs, AnalysisSubmissionStatusBadge as Nt, SecondaryContentWrapper as Qe, ConfirmationDialog as De, BaseInfoWrapper as Ot, AnalysisResultsBaseInfo as Pt, TabsNavigationNew as wt, ErrorBoundary as Dt, ErrorPage as qe, FileExplorer as Lt, SpinnerContainer as bs, NestedInfoWrapper as Is, AnalysisBaseInfo as Rs, Versions as js, ExportMultipleSource as As } from "@prometheus/features";
import { ModalContext as _e, useDownloadAnalysisTypes as Ut, useAnalysisImport as vs, DialogContext as kt, useInterval as _s, useExport as Ns, useDesign as Os } from "@prometheus/hooks";
import { Status as S, EntityActions as Ps } from "@prometheus/types";
import { useNavigate as me, Outlet as ws, useParams as at, Routes as Ce, Route as H, matchPath as xt } from "react-router-dom";
import { api as j, getSortDirection as Me, isEmpty as te, createCrudMethodsListConfig as Ds, createSortingMethodListConfig as Ls, createFiltersPanelListConfig as Us, generateAlias as ks, getReducerWithProduce as it, getCodeLanguageByFileExtension as Ft, getUUID as Fs, createBreadcrumbsEntityConfig as zs, parseFiltersToStringParams as Ms, formatFilterListNoFiql as $s, getExecutionDuration as Gs, getFileExtension as Bs, getFileIconName as Ws, formatBytes as Hs, getFormatDateAndTime as Le, getFullNameUser as Ys } from "@prometheus/utils";
import { AnalysisTypes as T, TypesOfContainer as J, containerTypes as Vs, FileExtension as Ue, ImportAtlasAsset as Pe, AnalysisSubmissionStatus as v, DateEdge as ht, EntityTypes as Qs } from "@prometheus/enums";
import { serializeCostEntity as qs, deserializeCostEntity as Xs, parseSimpleCountFormatResult as Ks, parseSimpleCountDesign as Js, getSimpleCohortTemplate as Zs, simpleCountTemplateList as en, SimpleCountResults as tn, SimpleCount as sn, parseSimpleCountCharacterizationFormatResult as nn, parseSimpleCountCharacterizationDesign as an, getSimpleCohortCharacterizationTemplate as rn, simpleCountCharacterizationTemplateList as on, SimpleCountWithCharacterizationResults as ln, SimpleCountWithCharacterization as cn, parseBulkCohortCountsFormatResults as un, parseBulkCohortCountsDesign as dn, getBulkCohortCountsTemplate as pn, bulkCohortCountsTemplateList as mn, BulkCohortCountsResults as yn, BulkCohortCounts as xn, parseIncidenceFormatResult as hn, parseIncidenceDesign as En, getIncidenceTemplate as Sn, incidenceRateTemplateList as gn, IncidenceResults as Cn, Incidence as Tn, parseCharacterizationFormatResult as fn, parseCharacterizationDesign as bn, getCharacterizationTemplate as In, characterizationTemplateList as Rn, CharacterizationResults as jn, Characterization as An, parsePathwayFormatResult as vn, parsePathwayDesign as _n, getPathwayTemplate as Nn, pathwayTemplateList as On, PathwayResults as Pn, Pathway as wn, parseFeasibilityFormatResult as Dn, parseFeasibilityDesign as Ln, getFeasibilityTemplate as Un, feasibilityTemplateList as kn, FeasibilityResults as Fn, Feasibility as zn, parseEstimationDesign as Mn, getEstimationTemplate as $n, estimationTemplateList as Gn, EstimationResults as Bn, Estimation as Wn, parsePredictionDesign as Hn, getPredictionTemplate as Yn, PredictionResults as Vn, Prediction as Qn, CustomResults as qn, Custom as Xn, StrategusResults as Kn, Strategus as Jn, parseDataCutFormatResult as Zn, parseDataCutDesign as ea, cohortBasedDataCutTemplateList as ta, CohortBasedDataCutResults as sa, CohortBasedDataCut as na, templateListTimeToEvent as aa, TimeToEventResult as ia, TimeToEvent as ra, createEmptyCostAnalysis as oa, templateCostUtilization as la, CostUtilizationResults as ca, CostUtilization as ua } from "@prometheus/plugins";
import { useSelector as zt, useDispatch as $e } from "react-redux";
import { getSummary as da, setBreadcrumbs as rt } from "@prometheus/redux";
import N from "@emotion/styled";
var Xe = { exports: {} }, Ie = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Et;
function pa() {
  if (Et) return Ie;
  Et = 1;
  var s = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(o, c, l) {
    var i = null;
    if (l !== void 0 && (i = "" + l), c.key !== void 0 && (i = "" + c.key), "key" in c) {
      l = {};
      for (var x in c)
        x !== "key" && (l[x] = c[x]);
    } else l = c;
    return c = l.ref, {
      $$typeof: s,
      type: o,
      key: i,
      ref: c !== void 0 ? c : null,
      props: l
    };
  }
  return Ie.Fragment = t, Ie.jsx = n, Ie.jsxs = n, Ie;
}
var Re = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var St;
function ma() {
  return St || (St = 1, process.env.NODE_ENV !== "production" && function() {
    function s(a) {
      if (a == null) return null;
      if (typeof a == "function")
        return a.$$typeof === Q ? null : a.displayName || a.name || null;
      if (typeof a == "string") return a;
      switch (a) {
        case C:
          return "Fragment";
        case E:
          return "Profiler";
        case f:
          return "StrictMode";
        case w:
          return "Suspense";
        case M:
          return "SuspenseList";
        case U:
          return "Activity";
      }
      if (typeof a == "object")
        switch (typeof a.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), a.$$typeof) {
          case g:
            return "Portal";
          case P:
            return (a.displayName || "Context") + ".Provider";
          case b:
            return (a._context.displayName || "Context") + ".Consumer";
          case X:
            var I = a.render;
            return a = a.displayName, a || (a = I.displayName || I.name || "", a = a !== "" ? "ForwardRef(" + a + ")" : "ForwardRef"), a;
          case R:
            return I = a.displayName || null, I !== null ? I : s(a.type) || "Memo";
          case L:
            I = a._payload, a = a._init;
            try {
              return s(a(I));
            } catch {
            }
        }
      return null;
    }
    function t(a) {
      return "" + a;
    }
    function n(a) {
      try {
        t(a);
        var I = !1;
      } catch {
        I = !0;
      }
      if (I) {
        I = console;
        var O = I.error, z = typeof Symbol == "function" && Symbol.toStringTag && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return O.call(
          I,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          z
        ), t(a);
      }
    }
    function o(a) {
      if (a === C) return "<>";
      if (typeof a == "object" && a !== null && a.$$typeof === L)
        return "<...>";
      try {
        var I = s(a);
        return I ? "<" + I + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function c() {
      var a = ne.A;
      return a === null ? null : a.getOwner();
    }
    function l() {
      return Error("react-stack-top-frame");
    }
    function i(a) {
      if (ae.call(a, "key")) {
        var I = Object.getOwnPropertyDescriptor(a, "key").get;
        if (I && I.isReactWarning) return !1;
      }
      return a.key !== void 0;
    }
    function x(a, I) {
      function O() {
        oe || (oe = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          I
        ));
      }
      O.isReactWarning = !0, Object.defineProperty(a, "key", {
        get: O,
        configurable: !0
      });
    }
    function h() {
      var a = s(this.type);
      return de[a] || (de[a] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), a = this.props.ref, a !== void 0 ? a : null;
    }
    function u(a, I, O, z, _, $, ie, pe) {
      return O = $.ref, a = {
        $$typeof: m,
        type: a,
        key: I,
        props: $,
        _owner: _
      }, (O !== void 0 ? O : null) !== null ? Object.defineProperty(a, "ref", {
        enumerable: !1,
        get: h
      }) : Object.defineProperty(a, "ref", { enumerable: !1, value: null }), a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(a, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(a, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ie
      }), Object.defineProperty(a, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: pe
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    }
    function p(a, I, O, z, _, $, ie, pe) {
      var k = I.children;
      if (k !== void 0)
        if (z)
          if (ye(k)) {
            for (z = 0; z < k.length; z++)
              r(k[z]);
            Object.freeze && Object.freeze(k);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else r(k);
      if (ae.call(I, "key")) {
        k = s(a);
        var se = Object.keys(I).filter(function(Ge) {
          return Ge !== "key";
        });
        z = 0 < se.length ? "{key: someKey, " + se.join(": ..., ") + ": ...}" : "{key: someKey}", xe[k + z] || (se = 0 < se.length ? "{" + se.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          z,
          k,
          se,
          k
        ), xe[k + z] = !0);
      }
      if (k = null, O !== void 0 && (n(O), k = "" + O), i(I) && (n(I.key), k = "" + I.key), "key" in I) {
        O = {};
        for (var re in I)
          re !== "key" && (O[re] = I[re]);
      } else O = I;
      return k && x(
        O,
        typeof a == "function" ? a.displayName || a.name || "Unknown" : a
      ), u(
        a,
        k,
        $,
        _,
        c(),
        O,
        ie,
        pe
      );
    }
    function r(a) {
      typeof a == "object" && a !== null && a.$$typeof === m && a._store && (a._store.validated = 1);
    }
    var d = Rt, m = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), C = Symbol.for("react.fragment"), f = Symbol.for("react.strict_mode"), E = Symbol.for("react.profiler"), b = Symbol.for("react.consumer"), P = Symbol.for("react.context"), X = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), M = Symbol.for("react.suspense_list"), R = Symbol.for("react.memo"), L = Symbol.for("react.lazy"), U = Symbol.for("react.activity"), Q = Symbol.for("react.client.reference"), ne = d.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ae = Object.prototype.hasOwnProperty, ye = Array.isArray, ue = console.createTask ? console.createTask : function() {
      return null;
    };
    d = {
      react_stack_bottom_frame: function(a) {
        return a();
      }
    };
    var oe, de = {}, A = d.react_stack_bottom_frame.bind(
      d,
      l
    )(), le = ue(o(l)), xe = {};
    Re.Fragment = C, Re.jsx = function(a, I, O, z, _) {
      var $ = 1e4 > ne.recentlyCreatedOwnerStacks++;
      return p(
        a,
        I,
        O,
        !1,
        z,
        _,
        $ ? Error("react-stack-top-frame") : A,
        $ ? ue(o(a)) : le
      );
    }, Re.jsxs = function(a, I, O, z, _) {
      var $ = 1e4 > ne.recentlyCreatedOwnerStacks++;
      return p(
        a,
        I,
        O,
        !0,
        z,
        _,
        $ ? Error("react-stack-top-frame") : A,
        $ ? ue(o(a)) : le
      );
    };
  }()), Re;
}
process.env.NODE_ENV === "production" ? Xe.exports = pa() : Xe.exports = ma();
var e = Xe.exports;
const Ne = (s) => (s == null ? void 0 : s.type) === T.COST ? Xs(s) : s, ot = (s) => (s == null ? void 0 : s.type) === T.COST ? qs(s) : s, ya = (s) => {
  const { pageNumber: t, pageSize: n, sortBy: o, query: c } = s, l = Me(o), i = `/analyses/list?size=${n || ""}&page=${t || ""}&sort=${l}&${c || ""}`;
  return j.get(i);
}, xa = (s) => {
  const { pageNumber: t, pageSize: n, sortBy: o, query: c } = s, l = Me(o), i = `/workspace/analyses/list?size=${n || ""}&page=${t || ""}&sort=${l}&${c || ""}`;
  return j.get(i);
}, ha = (s, t) => {
  const { pageNumber: n, pageSize: o, sortBy: c, query: l } = t, i = Me(c), x = `/studies/${s}/analyses/list?size=${o || ""}&page=${n || ""}&sort=${i}&${l || ""}`;
  return j.get(x);
}, Ea = (s) => {
  const t = `/analyses/filter?${s}`;
  return j.get(t);
}, Sa = (s) => {
  const t = `/workspace/analyses/filter?${s}`;
  return j.get(t);
}, ga = (s, t) => {
  const n = `/studies/${t}/analyses/filter?${s}`;
  return j.get(n);
}, ke = (s) => j.get(`/analyses/${s}`).then(Ne), Mt = (s) => j.delete(`/analyses/${s}`), lt = (s, t) => (t == null ? void 0 : t.type) === T.COST ? (
  // Cost keeps its dedicated endpoint (matches the /cost import + /cost/cpi
  // convention); only the design body shape changed (PRO-3934/3978).
  j.put(`/analysis/cost/${s}`, ot(t)).then(Ne)
) : j.put(`/analysis/${s}`, t), ct = (s) => j.post("/workspace/analyses", ot(s)).then(Ne), $t = (s, t) => j.post(`/workspace/analyses/copy/${s}`, t ? { name: t } : {}), Gt = (s, t) => j.post(`/studies/${s}/analyses`, ot(t)).then(Ne), Bt = (s, t, n) => j.post(
  `/studies/${s}/analyses/copy/${t}`,
  n ? { name: n } : {}
), Ca = (s, t) => t !== "new" ? lt(t, s) : ct(s), Ta = (s, t, n) => t !== "new" ? lt(t, s) : Gt(n, s), fa = () => j.get("/analyses/sorts"), ba = () => j.get("/workspace/analyses/sorts"), Ia = (s, t) => {
  const { pageNumber: n, pageSize: o, sortBy: c, query: l } = t, i = Me(c), x = `/analyses/${s}/batches/list?size=${o || 1e4}&page=${n || 0}&sort=${i}&${l || ""}`;
  return j.get(x).catch((h) => (console.error(h), []));
}, Ra = (s) => {
  const t = `/analyses/batches/${s}`;
  return j.get(t);
}, ja = (s) => {
  const t = `/submissions/${s}`;
  return j.get(t);
}, gt = (s) => {
  const t = `/submissions/${s}/results`;
  return j.get(t);
}, Aa = (s, t) => {
  const n = `/analyses/${s}/batches/filter?${t}`;
  return j.get(n);
}, va = (s) => {
  const t = `/submissions/${s}/approve`;
  return j.post(t);
}, _a = (s, t) => {
  const n = `/submissions/${s}/dismiss`;
  return j.post(n, t);
}, Na = (s) => {
  const t = `/submissions/${s}/approve-publishing`;
  return j.post(t);
}, Oa = (s, t) => {
  const n = `/submissions/${s}/dismiss-publishing`;
  return j.post(n, t);
}, Pa = (s) => {
  const t = `/submissions/${s}/cancel`;
  return j.post(t);
}, wa = (s, t) => j.post(`/submissions/${s}/results/upload/zip`, t), Da = (s) => j.get(`/submissions/${s}/history`), La = (s, t, n) => {
  const o = `/analyses/${s}/batches`;
  return j.post(o, { dataSourceIds: t, vaults: n });
}, Ua = (s) => j.get(`/analyses/${s}/versions?size=10000`), ka = (s) => j.get(`/analyses/version/${s}`).then(Ne), Fa = (s, t, n, o) => j.post(
  encodeURI(`/atlas/${s}/assets/${t}/export`),
  {},
  {
    params: {
      id: n,
      name: o
    },
    paramsSerializer: (c) => {
      let l = "";
      return Object.keys(c).forEach((i) => {
        l += `${i}=${encodeURIComponent(c[i])}&`;
      }), l.substring(0, l.length - 1);
    }
  }
), za = (s) => j.get(`/analyses/${s}/summary`), Wt = Te(
  (s) => {
    var m;
    const { parentId: t, afterCreate: n, onCancel: o, createMethod: c, analysesTypes: l } = s, [i, x] = Y(!1), [h, u] = Y({
      title: "",
      type: (m = Object.keys(l)) == null ? void 0 : m[0],
      studyId: t
    }), [p, r] = Y({
      useAgeGroups: !0,
      useGender: !0,
      useEthnicity: !1,
      useRace: !1
    }), d = q(() => {
      x(!0), c(
        h.type === T.SIMPLE_COUNTS_CHARACTERIZATION ? {
          ...h,
          ...p
        } : h
      ).then((g) => {
        x(!1), n == null || n(g);
      });
    }, [t, h, c]);
    return /* @__PURE__ */ e.jsx(y, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(Se, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ee, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ e.jsx(
        Ae,
        {
          id: "title",
          name: "title",
          type: "text",
          size: "medium",
          value: h.title,
          placeholder: "Enter title",
          onChange: (g) => u({ ...h, title: g.target.value }),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(ee, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ e.jsx(
        je,
        {
          className: "",
          name: "type",
          disablePortal: !0,
          id: "type",
          options: Object.values(l).map((g) => ({
            name: g.title,
            value: g.type
          })),
          value: h.type,
          placeholder: "Select type",
          onChange: (g) => {
            u({ ...h, type: g });
          },
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(nt, { children: [
        /* @__PURE__ */ e.jsx(
          B,
          {
            variant: "outlined",
            disabled: i,
            onClick: o,
            startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ e.jsx(
          B,
          {
            disabled: i || te(h.title) || te(h.type),
            onClick: d,
            variant: "contained",
            color: "success",
            startIcon: i ? /* @__PURE__ */ e.jsx(W, { size: 16 }) : /* @__PURE__ */ e.jsx(D, { iconName: "submit" }),
            name: "save",
            children: "Save"
          }
        )
      ] }) })
    ] }) }) });
  }
), Ma = (s) => {
  const t = me(), { openModal: n, closeModal: o } = Z(_e), { enqueueSnackbar: c } = ve(), l = (i) => {
    i.stopPropagation(), n(
      () => /* @__PURE__ */ e.jsx(
        Wt,
        {
          analysesTypes: s.analysesTypes,
          parentId: null,
          createMethod: ct,
          onCancel: o,
          afterCreate: (x) => {
            c({
              message: "Analysis created successfullly",
              variant: "success"
            }), t(`/workspace/analyses/${x.id}`), o();
          }
        }
      ),
      "Create analysis",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: o
      }
    );
  };
  return /* @__PURE__ */ e.jsx(
    us,
    {
      title: "Analyses",
      description: "Analysis is a specific type of a data analytics question within a study. It can range from simple feasibility counts and characterization  to a more complex population level effect estimation and patient prediction.",
      iconName: "analyses",
      onCardClick: () => t("/workspace/analyses"),
      children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 90, textAlign: "right", children: /* @__PURE__ */ e.jsx(
        B,
        {
          onClick: l,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "add" }),
          name: "save",
          children: "Create"
        }
      ) })
    }
  );
}, Ke = (s, t) => Ds(
  s,
  t,
  ya,
  Mt,
  ha,
  xa
), Ct = (s, t) => Us(
  s,
  t,
  Ea,
  ga,
  Sa
), $a = (s) => Ls(s, {
  getSorting: fa,
  getSortingWorkspace: ba
}), Je = (s, t) => {
  switch (s) {
    case J.WORKSPACE:
      return (n) => ct(n);
    case J.STUDY:
      return (n) => Gt(t, n);
  }
}, Tt = [
  ds({ cell: ze }),
  ps(),
  ms({ accessorKey: "title", id: "title" }),
  ys(),
  xs(),
  hs()
], Ga = {
  form: {
    entityId: void 0,
    title: void 0,
    type: void 0,
    attribute: void 0,
    studyId: void 0,
    typeContainer: void 0,
    createNew: !1,
    analysis: void 0
  },
  analysisList: [],
  status: S.INITIAL
}, Ba = (s, t) => it(s, (n) => {
  switch (t.type) {
    case "INIT":
      n.form = t.payload;
      break;
    case "UPDATE":
      n.form[t.payload.prop] = t.payload.value;
      break;
    case "FETCH_ANAKYSES":
      n.form.analysis = void 0, n.analysisList = [];
      break;
    case "FETCH_ANAKYSES_DONE":
      n.analysisList = t.payload;
      break;
    case "SAVE_PROGRESS":
      n.status = S.IN_PROGRESS;
      break;
    case "SAVE_DONE":
      n.status = S.SUCCESS, n.form.analysis = t.payload;
      break;
    case "SAVE_FAILED":
      n.status = S.ERROR;
      break;
  }
}), Wa = (s, t) => {
  const [n, o] = et(Ba, Ga), c = (h) => {
    o({
      type: "INIT",
      payload: h
    });
  }, l = q(async () => {
    var u;
    if (!n.form.typeContainer || !n.form.type || !n.form.attribute || (n.form.createNew ? !n.form.title : !((u = n.form.analysis) != null && u.id)))
      return;
    o({
      type: "SAVE_PROGRESS"
      /* SAVE_PROGRESS */
    });
    const h = Je(
      n.form.typeContainer,
      n.form.studyId
    );
    try {
      const p = n.form.createNew ? await h({
        title: n.form.title,
        type: n.form.type,
        studyId: n.form.studyId
      }) : await ke(n.form.analysis.id), r = p.design || {}, d = n.form.type === T.CUSTOM ? {
        ...t,
        alias: ks(t)
      } : t, m = await lt(p.id, {
        ...p,
        design: {
          ...r,
          [n.form.attribute]: n.form.type === T.COHORT || n.form.type === T.SIMPLE_COUNTS_CHARACTERIZATION ? t.versionId : r != null && r[n.form.attribute] ? [...r == null ? void 0 : r[n.form.attribute], d] : [d]
        }
      });
      o({
        type: "SAVE_DONE",
        payload: m
      });
    } catch {
      o({
        type: "SAVE_FAILED"
        /* SAVE_FAILED */
      });
    }
  }, [n.form]), i = q(async () => {
    const h = Ke(
      n.form.typeContainer,
      n.form.studyId
    );
    o({
      type: "FETCH_ANAKYSES"
      /* FETCH_ANALYSES */
    });
    try {
      const u = await h.fetch(0, 1e5);
      o({
        type: "FETCH_ANAKYSES_DONE",
        payload: u.content.filter((p) => p.type === n.form.type)
      });
    } catch {
    }
  }, [n.form.typeContainer, n.form.studyId, n.form.type]), x = (h, u) => {
    o({
      type: "UPDATE",
      payload: {
        prop: h,
        value: u
      }
    });
  };
  return V(() => {
    c(s);
  }, []), V(() => {
    n.form.typeContainer && i();
  }, [n.form.typeContainer, n.form.studyId, n.form.type]), {
    ...n,
    updateForm: x,
    saveAnalysis: l
  };
}, Ye = (s = []) => {
  var t, n;
  return ((t = s.find((o) => {
    var i, x;
    const c = ((i = o.name) == null ? void 0 : i.toLowerCase()) || "", l = ((x = o.value) == null ? void 0 : x.toLowerCase()) || "";
    return c.includes("target") || l.includes("target");
  })) == null ? void 0 : t.value) || ((n = s[0]) == null ? void 0 : n.value);
}, Ha = (s) => {
  var w, M;
  const {
    analysesTypes: t,
    onCancel: n,
    entity: o,
    analysisType: c,
    subModules: l,
    typeContainer: i,
    parentId: x
  } = s, h = me(), { enqueueSnackbar: u } = ve(), p = c || ((w = Object.keys(t)) == null ? void 0 : w[0]), { form: r, analysisList: d, updateForm: m, saveAnalysis: g, status: C } = Wa(
    {
      title: o.name,
      type: p,
      attribute: Ye(
        (M = t[p]) == null ? void 0 : M.templateList
      ),
      studyId: x,
      typeContainer: i,
      createNew: !0,
      analysis: void 0
    },
    o
  );
  V(() => {
    C === S.SUCCESS && (u({
      message: `Created anaysis ${r.analysis.title} with cohort ${o.name}`,
      variant: "success"
    }), h(
      r.typeContainer === J.WORKSPACE ? `workspace/analyses/${r.analysis.id}` : `study-manager/${r.studyId}/analyses/${r.analysis.id}`
    ), n());
  }, [C]);
  const f = G(() => {
    var R;
    return ((R = t[r.type]) == null ? void 0 : R.templateList) || [];
  }, [t, r.type]), E = G(() => Ye(f), [f]);
  V(() => {
    if (!f.length) {
      te(r.attribute) || m("attribute", void 0);
      return;
    }
    f.some(
      (L) => L.value === r.attribute
    ) || m("attribute", E);
  }, [f, r.attribute, E]);
  const b = () => {
    const R = !r.createNew;
    m("createNew", R), m("analysis", void 0), m("title", R ? o.name : void 0), E && m("attribute", E);
  }, P = C === S.IN_PROGRESS || (r.createNew ? te(r.title) : te(r.analysis)) || te(r.typeContainer) || te(r.type) || f.length > 0 && te(r.attribute), X = r.type === T.CUSTOM ? "Referenced Cohorts" : "Template attribute";
  return r.type ? /* @__PURE__ */ e.jsx(y, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(Se, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ee, { variant: "h3", children: "Container:" }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ee, { name: "typeContainer", textLabel: "Add to", required: !0, children: /* @__PURE__ */ e.jsx(
      je,
      {
        className: "",
        name: "typeContainer",
        disablePortal: !0,
        id: "typeContainer",
        options: Vs.filter((R) => R.value !== "ATLAS"),
        value: r.typeContainer,
        placeholder: "Select type",
        onChange: (R) => {
          m("typeContainer", R);
        },
        fullWidth: !0
      }
    ) }) }),
    r.typeContainer === J.STUDY && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ee, { name: "study", textLabel: "Study", required: !0, children: /* @__PURE__ */ e.jsx(
      l.study,
      {
        type: "component",
        name: "user-studies-list",
        subModules: l,
        config: {
          onChange: (R) => {
            R && m("studyId", R.id);
          },
          studyInitialId: x
        }
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ee, { variant: "h3", children: "Analysis:" }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(ee, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ e.jsx(
      je,
      {
        className: "",
        name: "type",
        disablePortal: !0,
        id: "type",
        options: Object.keys(t).filter((R) => {
          var L, U;
          return ![
            T.STRATEGUS,
            T.ESTIMATION
          ].includes(R) && ((U = (L = t[R]) == null ? void 0 : L.templateList) == null ? void 0 : U.length) > 0;
        }).map((R) => ({
          name: t[R].title,
          value: t[R].type
        })),
        value: r.type,
        disabled: c != null,
        placeholder: "Select type",
        onChange: (R) => {
          var L;
          m("type", R), m(
            "attribute",
            Ye((L = t[R]) == null ? void 0 : L.templateList)
          );
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
      /* @__PURE__ */ e.jsx(
        is,
        {
          name: "createNew",
          onChange: b,
          checked: r.createNew
        }
      ),
      /* @__PURE__ */ e.jsx(Ee, { sx: { marginLeft: "5px" }, variant: "caption", children: "Create new analysis" })
    ] }),
    r.createNew && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ee, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ e.jsx(
      Ae,
      {
        id: "title",
        name: "title",
        type: "text",
        size: "medium",
        value: r.title,
        placeholder: "Enter title",
        onChange: (R) => (
          // setState({ ...state, title: e.target.value })
          m("title", R.target.value)
        ),
        fullWidth: !0
      }
    ) }) }),
    !r.createNew && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ee, { name: "analysis", textLabel: "Analysis", required: !0, children: /* @__PURE__ */ e.jsx(
      rs,
      {
        className: "",
        name: "analysis",
        id: "analysis",
        options: d,
        value: r.analysis,
        placeholder: "Select analysis...",
        fullWidth: !0,
        isOptionEqualToValue: (R, L) => R.id === (L == null ? void 0 : L.id),
        onChange: (R, L) => {
          m("analysis", L);
        },
        getOptionLabel: (R) => R.title
      }
    ) }) }),
    f.length > 0 && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      ee,
      {
        name: "templateProp",
        textLabel: X,
        required: !0,
        children: /* @__PURE__ */ e.jsx(
          je,
          {
            className: "",
            name: "templateProp",
            disablePortal: !0,
            id: "templateProp",
            options: f,
            value: r.attribute,
            placeholder: "Select attribute",
            onChange: (R) => {
              m("attribute", R);
            },
            fullWidth: !0
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(nt, { children: [
      /* @__PURE__ */ e.jsx(
        B,
        {
          variant: "outlined",
          onClick: n,
          startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ e.jsx(
        B,
        {
          disabled: P,
          onClick: g,
          variant: "contained",
          color: "success",
          startIcon: C === S.IN_PROGRESS ? /* @__PURE__ */ e.jsx(W, { size: 16 }) : /* @__PURE__ */ e.jsx(D, { iconName: "submit" }),
          name: "save",
          children: "Add"
        }
      )
    ] }) })
  ] }) }) }) : /* @__PURE__ */ e.jsx(e.Fragment, {});
}, Ht = [
  {
    component: sn,
    results: tn,
    templateList: en,
    getTemplate: Zs,
    url: "cohort",
    type: T.COHORT,
    title: "Cohort Counts",
    parseDesign: Js,
    formatDesign: Ks,
    atlasEntity: null
  },
  {
    component: cn,
    results: ln,
    templateList: on,
    getTemplate: rn,
    url: "simple-counts-characterization",
    type: T.SIMPLE_COUNTS_CHARACTERIZATION,
    title: "Cohort Counts with Demographics",
    parseDesign: an,
    formatDesign: nn,
    atlasEntity: null
  },
  {
    component: xn,
    results: yn,
    templateList: mn,
    getTemplate: pn,
    url: "bulk-cohort-counts",
    type: T.BULK_COHORT_COUNTS,
    title: "Cohort Counts with Demographics (Multi)",
    parseDesign: dn,
    formatDesign: un,
    atlasEntity: null
  },
  {
    component: Tn,
    results: Cn,
    templateList: gn,
    getTemplate: Sn,
    url: "incidence-rate",
    type: T.INCIDENCE,
    title: "Incidence Rates",
    parseDesign: En,
    formatDesign: hn,
    atlasEntity: "IR",
    localConceptSet: !0,
    conceptSetAttr: "conceptSets"
  },
  {
    component: An,
    results: jn,
    templateList: Rn,
    getTemplate: In,
    url: "cohort-characterization",
    type: T.COHORT_CHARACTERIZATION,
    title: "Cohort Characterization",
    parseDesign: bn,
    formatDesign: fn,
    atlasEntity: "CC",
    localConceptSet: !0,
    conceptSetAttr: "strataConceptSets"
  },
  {
    component: wn,
    results: Pn,
    templateList: On,
    getTemplate: Nn,
    url: "pathway",
    type: T.COHORT_PATHWAY,
    title: "Cohort Pathway",
    parseDesign: _n,
    formatDesign: vn,
    atlasEntity: "PATHWAY"
  },
  {
    component: zn,
    results: Fn,
    templateList: kn,
    getTemplate: Un,
    url: "feasibility",
    type: T.FEASIBILITY,
    title: "Feasibility",
    parseDesign: Ln,
    formatDesign: Dn,
    atlasEntity: "FEASIBILITY"
  },
  {
    component: Wn,
    results: Bn,
    templateList: Gn,
    getTemplate: $n,
    url: "estimation",
    type: T.ESTIMATION,
    title: "Population Level Estimation",
    parseDesign: Mn,
    atlasEntity: "PLE"
  },
  {
    component: Qn,
    results: Vn,
    getTemplate: Yn,
    url: "prediction",
    type: T.PREDICTION,
    title: "Prediction",
    parseDesign: Hn,
    atlasEntity: "PLP"
  },
  {
    component: Xn,
    results: qn,
    templateList: [
      {
        name: "Referenced Cohorts",
        value: "cohorts"
      }
    ],
    getTemplate: () => ({}),
    url: "custom",
    isUpload: !0,
    type: T.CUSTOM,
    title: "Custom",
    atlasEntity: null
  },
  {
    component: Jn,
    results: Kn,
    getTemplate: () => ({}),
    url: "strategus",
    isUpload: !0,
    type: T.STRATEGUS,
    title: "Strategus",
    atlasEntity: null
  },
  {
    component: na,
    results: sa,
    templateList: ta,
    getTemplate: () => {
    },
    url: "datacut",
    type: T.DATACUT,
    title: "Cohort Export",
    parseDesign: ea,
    formatDesign: Zn,
    atlasEntity: null
  },
  {
    component: ra,
    results: ia,
    templateList: aa,
    getTemplate: () => ({
      targetCohorts: [],
      eventCohorts: [],
      minDaysToEvent: 1,
      restrictedMeanFollowUp: null,
      outcomeWashout: null,
      summaryReportTimesUnit: "days"
    }),
    url: "time-to-event",
    type: T.TIME_TO_EVENT,
    title: "Time to Event",
    parseDesign: (s, t) => ({
      ...t,
      type: s.type
    }),
    // formatDesign: d => d,
    atlasEntity: null
  },
  {
    component: ua,
    results: ca,
    templateList: la,
    getTemplate: () => ({
      targetCohorts: [],
      analyses: [oa(0)]
    }),
    url: "cost",
    type: T.COST,
    title: "Cost Utilization",
    parseDesign: (s, t) => ({
      ...t,
      type: s.type
    }),
    // formatDesign: d => d,
    atlasEntity: null
  }
], Ya = Te((s) => {
  const { name: t } = s, n = zt((l) => l.user), { analyses: o, status: c } = Ut({
    preloadAnalysisTypes: s.config.analysisTypes,
    analyses: Ht,
    tenantId: n.data.activeTenant
  });
  return [S.INITIAL, S.IN_PROGRESS].includes(c) ? /* @__PURE__ */ e.jsx(fe, { children: /* @__PURE__ */ e.jsx(W, { size: 32 }) }) : /* @__PURE__ */ e.jsxs(Rt.Fragment, { children: [
    t === "home-widget-analysis" && /* @__PURE__ */ e.jsx(Ma, { ...s, analysesTypes: o }),
    t === "create-analysis-from-cohort" && /* @__PURE__ */ e.jsx(
      Ha,
      {
        ...s.config,
        subModules: s.subModules,
        analysesTypes: o
      }
    )
  ] });
}), Va = Te(
  (s) => {
    var f;
    const { onCancel: t, typeContainer: n, parentId: o, onChange: c, analysesTypes: l } = s, [i, x] = Y({
      title: void 0,
      type: (f = Object.keys(l)) == null ? void 0 : f[0],
      design: "",
      cohortName: void 0
    }), { enqueueSnackbar: h } = ve(), { createNewAnalysis: u, status: p, entity: r } = vs(), d = G(
      () => Ft(Ue.JSON),
      []
    ), m = (E) => {
      const b = typeof E == "string" ? { design: E } : { [E.target.name]: E.target.value };
      x((P) => ({ ...P, ...b }));
    }, g = async (E) => {
      E.preventDefault(), await u(
        i,
        n,
        o,
        l[i.type]
      );
    };
    V(() => {
      p === S.SUCCESS ? (h({
        message: "Analysis created successfully",
        variant: "success"
      }), c(r.id)) : p === S.ERROR && h({
        message: "Oops! Something went wrong",
        variant: "error"
      });
    }, [p, r]);
    const C = () => i.type === T.COHORT || i.type === T.SIMPLE_COUNTS_CHARACTERIZATION ? te(i.title) || te(i.cohortName) : !1;
    return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(ee, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ e.jsx(
        je,
        {
          className: "",
          name: "type",
          disablePortal: !0,
          id: "type",
          options: Object.keys(l).map((E) => ({
            name: l[E].title,
            value: l[E].type
          })).filter(
            (E) => E.value !== T.CUSTOM && E.value !== T.STRATEGUS
          ),
          value: i.type,
          placeholder: "Select type",
          onChange: (E) => {
            x({ ...i, type: E });
          },
          fullWidth: !0
        }
      ) }) }),
      (i.type === T.COHORT || i.type === T.SIMPLE_COUNTS_CHARACTERIZATION) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(ee, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ e.jsx(
          Ae,
          {
            id: "title",
            name: "title",
            type: "text",
            size: "medium",
            value: i.title,
            placeholder: "Enter title",
            onChange: (E) => x({ ...i, title: E.target.value }),
            fullWidth: !0
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(ee, { name: "cohortName", textLabel: "Cohort name", required: !0, children: /* @__PURE__ */ e.jsx(
          Ae,
          {
            id: "cohortName",
            name: "cohortName",
            type: "text",
            size: "medium",
            value: i.cohortName,
            placeholder: "Enter cohort name",
            onChange: (E) => x({ ...i, cohortName: E.target.value }),
            fullWidth: !0
          }
        ) }) })
      ] }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        _t,
        {
          title: "",
          data: i.design,
          fileName: i.design || "File",
          language: d,
          onChange: m,
          fileExtension: Ue.JSON,
          contentType: Es.APPLICATION_JSON
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(nt, { children: [
        /* @__PURE__ */ e.jsx(
          B,
          {
            variant: "outlined",
            onClick: t,
            disabled: p === S.IN_PROGRESS,
            size: "small",
            startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ e.jsx(
          B,
          {
            disabled: p === S.IN_PROGRESS || !i.design || C() || te(i.type),
            onClick: g,
            variant: "contained",
            size: "small",
            color: "success",
            startIcon: p === S.IN_PROGRESS ? /* @__PURE__ */ e.jsx(W, { size: 16 }) : /* @__PURE__ */ e.jsx(D, { iconName: "submit" }),
            name: "save",
            children: "Import"
          }
        )
      ] }) })
    ] });
  }
);
var Yt = /* @__PURE__ */ ((s) => (s.CC = "COHORT_CHARACTERIZATION", s.PATHWAY = "PATHWAY", s.IR = "INCIDENCE_RATE", s.PLE = "ESTIMATION", s.FEASIBILITY = "FEASIBILITY", s))(Yt || {});
const Qa = ({ viewMode: s }) => {
  const t = me(), n = $e(), { enqueueSnackbar: o } = ve(), { openModal: c, closeModal: l } = Z(_e), i = Z(be), [x, h] = Y(), u = G(() => i == null ? void 0 : i.config, []), p = u.typeContainer === J.STUDY ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    "The available analyses for this study are limited to",
    " ",
    /* @__PURE__ */ e.jsx("b", { children: Object.values(i.analysesTypes).map((E) => E.title).join(", ") }),
    ". Other analyses may be disabled due to the current study configuration."
  ] }) : "", r = G(() => Je(u.typeContainer, u.parentId), [u.typeContainer, u.parentId]), d = () => {
    n(da(u.typeContainer, u.parentId));
  }, m = () => {
    c(
      () => /* @__PURE__ */ e.jsx(
        Wt,
        {
          analysesTypes: i.analysesTypes,
          parentId: u.parentId,
          createMethod: r,
          onCancel: l,
          afterCreate: (E) => {
            var b;
            o({
              message: "Analysis created successfully",
              variant: "success"
            }), t(E.id), l(), d(), (b = u == null ? void 0 : u.onReload) == null || b.call(u);
          }
        }
      ),
      "Add analysis",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: l
      }
    );
  }, g = (E) => {
    var b;
    return !((b = i.analysesTypes) != null && b[E.original.type]);
  }, C = G(() => [
    Pe.CC,
    Pe.PATHWAY,
    Pe.IR,
    Pe.PLE
  ].filter((E) => Object.keys(i.analysesTypes).includes(
    Yt[E]
  )), []), f = () => {
    c(
      () => {
        var E;
        return /* @__PURE__ */ e.jsx(
          gs,
          {
            name: "analyses",
            currentContainer: u.typeContainer,
            parentId: u.parentId,
            onChange: async () => {
              h(Fs()), l(), d();
            },
            createListMethods: Ke,
            cols: Tt,
            createListFiltersMethod: Ct,
            createMethodCreate: Je,
            subModules: i.subModules,
            isSelect: !0,
            hideConflictResolutionMethod: !0,
            hideConflictResolutionControls: !0,
            successMessage: "Analysis successfully copied",
            atlasEntity: C,
            disableImportContainer: !0,
            analysesTypes: i.analysesTypes,
            manualImport: !0,
            disableRowSelect: g,
            disableAltasImport: (C == null ? void 0 : C.length) === 0,
            disableManualImport: ((E = Object.keys(i.analysesTypes).filter(
              (b) => b !== T.CUSTOM && b !== T.STRATEGUS
            )) == null ? void 0 : E.length) === 0,
            alertText: p,
            manualImportComponent: /* @__PURE__ */ e.jsx(
              Va,
              {
                analysesTypes: i.analysesTypes,
                typeContainer: u.typeContainer,
                onCancel: l,
                parentId: u.parentId,
                onChange: (b) => {
                  var P;
                  t(b), l(), d(), (P = u == null ? void 0 : u.onReload) == null || P.call(u);
                }
              }
            )
          }
        );
      },
      "Import analysis",
      {
        onClose: l,
        closeOnClickOutside: !0
      }
    );
  };
  return /* @__PURE__ */ e.jsx(
    Ss,
    {
      reloadId: x,
      isImport: !0,
      onImport: f,
      onCreate: m,
      moduleConfig: i,
      viewMode: u.viewMode,
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading analyses...",
        addButtonTitle: "Add analysis",
        moduleDescription: "Analyses are standard or custom data analytics modules - including characterizations, estimation and predictions, that can be used to perform observation research on data.",
        tableTitle: "Analyses",
        importButtonTitle: "Import",
        listInitialSort: { id: "modified.timestamp", desc: !0 },
        createCrudMethod: Ke,
        createFiltersPanel: Ct,
        createSortingMethod: $a,
        cols: Tt
      },
      variant: "description",
      allowDelete: !0
    }
  );
}, qa = "New Analysis", Xa = (s, t) => ({
  get: (n) => ke(n),
  delete: (n) => Mt(n),
  update: (n, o) => {
    switch (s) {
      case J.STUDY:
        return Ta(n, o, t);
      case J.WORKSPACE:
        return Ca(n, o);
    }
  },
  copy: (n, o) => {
    switch (s) {
      case J.STUDY:
        return Bt(t, n, o);
      case J.WORKSPACE:
        return $t(n, o);
    }
  }
}), Ka = (s, t, n, o) => {
  const c = [
    {
      title: "Design",
      value: "",
      end: !0
    }
  ];
  return s && (!n || n && (t == null ? void 0 : t.length) > 0) && c.push({
    title: /* @__PURE__ */ e.jsx(
      He,
      {
        title: "Concept sets",
        count: (t == null ? void 0 : t.length) || 0,
        status: S.SUCCESS,
        dense: !0
      }
    ),
    value: "concept-sets"
  }), o.batches > 0 && c.push({
    title: /* @__PURE__ */ e.jsx(
      He,
      {
        title: "Results",
        count: o.batches || 0,
        status: S.SUCCESS,
        dense: !0
      }
    ),
    value: "executions"
  }), c.push({
    align: "right",
    iconOnly: !0,
    iconName: "reload",
    title: /* @__PURE__ */ e.jsx(
      He,
      {
        title: "Versions",
        count: o.versions || 0,
        status: S.SUCCESS,
        dense: !0
      }
    ),
    value: "versions"
  }), c;
}, Ja = {
  entityBreadcrumbs: (s, t, n) => zs(qa, s, t, n),
  apiMethodsVersioning: {
    getList: Ua,
    getCurrent: ka
  }
}, Za = (s) => {
  const {
    type: t,
    typeContainer: n,
    parentId: o,
    analysisId: c,
    subModules: l,
    afterCreate: i,
    onClose: x
  } = s, { enqueueSnackbar: h } = ve(), [u, p] = Y(S.INITIAL), [r, d] = Y([]), [m, g] = Y([]), C = async () => {
    p(S.IN_PROGRESS);
    try {
      await La(c, r, m), p(S.SUCCESS);
    } catch {
      p(S.ERROR);
    }
  };
  V(() => {
    u === S.SUCCESS && (h({
      message: "Analysis submitted",
      variant: "success"
    }), i()), u === S.ERROR && h({
      message: "Analysis was not submitted",
      variant: "error"
    });
  }, [u]);
  const f = G(() => u === S.IN_PROGRESS ? /* @__PURE__ */ e.jsx(W, { size: 18 }) : /* @__PURE__ */ e.jsx(D, { iconName: "submit" }), [u]);
  return /* @__PURE__ */ e.jsxs(
    y,
    {
      container: !0,
      px: 2,
      pt: 2,
      position: "relative",
      sx: { maxHeight: "calc(100vh - 116px)", overflowY: "auto" },
      children: [
        t === T.DATACUT ? /* @__PURE__ */ e.jsx(
          l.datasources,
          {
            type: "component",
            name: "data-source-list-with-vaults",
            subModules: l,
            config: {
              typeContainer: n,
              parentId: o,
              onAdd: (E, b) => {
                d(E), g(b);
              }
            }
          }
        ) : /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          jt,
          {
            elevation: 3,
            sx: { maxHeight: "calc(100vh - 150px)", overflowY: "auto" },
            children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              l.datasources,
              {
                type: "component",
                name: "data-source-list-in-study",
                subModules: l,
                config: {
                  analysisId: c,
                  typeContainer: n,
                  parentId: o,
                  onAdd: d
                }
              }
            ) })
          }
        ) }),
        /* @__PURE__ */ e.jsx(Cs, { item: !0, px: 2, py: 1, className: "visible", width: "700px", children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, py: 2, textAlign: "right", children: [
          /* @__PURE__ */ e.jsx(
            B,
            {
              variant: "outlined",
              onClick: x,
              startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "close" }),
              sx: { mr: 1 },
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              disabled: !(r.length > 0) || u === S.IN_PROGRESS,
              onClick: C,
              variant: "contained",
              color: "success",
              startIcon: f,
              children: "Submit"
            }
          )
        ] }) }) })
      ]
    }
  );
}, ei = (s, t, n, o) => (c, l) => {
  switch (s) {
    case J.STUDY:
      return Bt(t, c, l);
    case J.WORKSPACE:
      return $t(c, l);
    case "ATLAS":
      return Fa(n, o, c, l);
  }
}, ti = {
  executions: {
    data: [],
    pageCount: 0,
    totalElements: 0,
    numberOfElements: 0,
    pageNumber: 0,
    pageSize: 10
  },
  status: S.INITIAL,
  filters: { data: [], form: {} },
  progressExecutionIds: {}
}, si = (s, t) => it(s, (n) => {
  switch (t.type) {
    case "GET_EXECUTION_REQUEST":
      n.status = n.status === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD;
      break;
    case "GET_EXECUTION_REQUEST_DONE":
      n.executions.data = t.payload.executions.content, n.executions.pageCount = t.payload.executions.totalPages, n.executions.totalElements = t.payload.executions.totalElements, n.executions.numberOfElements = t.payload.executions.numberOfElements, n.executions.pageNumber = t.payload.executions.number, n.filters.data = t.payload.filters, n.status = S.SUCCESS;
      break;
    case "APPROVE_EXECUTION_REQUEST":
    case "DISMISS_EXECUTION_REQUEST":
      n.progressExecutionIds = {
        ...n.progressExecutionIds,
        [t.payload]: !0
      };
      break;
    case "APPROVE_EXECUTION_REQUEST_DONE":
    case "DISMISS_EXECUTION_REQUEST_DONE":
    case "EXECUTION_REQUEST_FAILED":
      n.progressExecutionIds[t.payload] = !1;
      break;
    case "GET_EXECUTION_REQUEST_FAILED":
      n.status = S.ERROR;
      break;
    case "UPDATE_FILTERS":
      const { key: o, value: c } = t.payload;
      n.filters.form[o] = c;
      break;
  }
}), ni = (s) => {
  const [t, n] = et(si, ti), [o, c] = Y(/* @__PURE__ */ new Set()), l = (d, m) => {
    n({
      type: "UPDATE_FILTERS",
      payload: { key: d, value: m }
    });
  }, i = q(
    async (d = t.executions.pageNumber, m = t.executions.pageSize) => {
      n({
        type: "GET_EXECUTION_REQUEST"
        /* GET_EXECUTION_REQUEST */
      });
      try {
        const g = Ms(t.filters.form), C = await Ia(s, {
          pageNumber: d,
          pageSize: m,
          // sortBy: sort,
          query: g
        }), f = await Aa(
          s,
          g
        ).then($s);
        n({
          type: "GET_EXECUTION_REQUEST_DONE",
          payload: { executions: C, filters: f }
        });
      } catch (g) {
        n({
          type: "GET_EXECUTION_REQUEST_FAILED",
          payload: g
        });
      }
    },
    [t.filters.form]
  ), x = q(
    async (d) => {
      n({
        type: "APPROVE_EXECUTION_REQUEST",
        payload: d
      });
      try {
        await va(d), await i(), n({
          type: "APPROVE_EXECUTION_REQUEST_DONE",
          payload: d
        });
      } catch (m) {
        n({
          type: "EXECUTION_REQUEST_FAILED",
          payload: d
        }), console.error(m);
      }
    },
    [t.executions]
  ), h = q(
    async (d, m) => {
      n({
        type: "DISMISS_EXECUTION_REQUEST",
        payload: d
      });
      try {
        await _a(d, m), await i(), n({
          type: "DISMISS_EXECUTION_REQUEST_DONE",
          payload: d
        });
      } catch (g) {
        n({
          type: "EXECUTION_REQUEST_FAILED",
          payload: d
        }), console.error(g);
      }
    },
    [t.executions]
  ), u = q(
    async (d, m) => {
      n({
        type: "APPROVE_EXECUTION_REQUEST",
        payload: d
      });
      try {
        await Na(d, m), await i(), n({
          type: "APPROVE_EXECUTION_REQUEST_DONE",
          payload: d
        });
      } catch (g) {
        n({
          type: "EXECUTION_REQUEST_FAILED",
          payload: d
        }), console.error(g);
      }
    },
    [t.executions]
  ), p = q(
    async (d, m) => {
      n({
        type: "DISMISS_EXECUTION_REQUEST",
        payload: d
      });
      try {
        await Oa(d, m), await i(), n({
          type: "APPROVE_EXECUTION_REQUEST_DONE",
          payload: d
        });
      } catch (g) {
        n({
          type: "EXECUTION_REQUEST_FAILED",
          payload: d
        }), console.error(g);
      }
    },
    [t.executions]
  ), r = q(
    async (d) => {
      n({
        type: "DISMISS_EXECUTION_REQUEST",
        payload: d
      });
      try {
        await Pa(d), c((m) => /* @__PURE__ */ new Set([...m, d])), await i(), n({
          type: "DISMISS_EXECUTION_REQUEST_DONE",
          payload: d
        });
      } catch (m) {
        n({
          type: "EXECUTION_REQUEST_FAILED",
          payload: d
        }), console.error(m);
      }
    },
    [t.executions]
  );
  return {
    ...t,
    submissionApprove: x,
    submissionDismiss: h,
    submissionApprovePublish: u,
    submissionDismissPublish: p,
    submissionCancel: r,
    cancelledIds: o,
    getExecutions: i,
    updateFilters: l
  };
};
var K = /* @__PURE__ */ ((s) => (s.GET_COMBINED_RESULTS = "GET_COMBINED_RESULTS", s.GET_COMBINED_RESULTS_DONE = "GET_COMBINED_RESULTS_DONE", s.GET_COMBINED_RESULTS_ERROR = "GET_COMBINED_RESULTS_ERROR", s.GET_RESULTS_REQUEST = "GET_RESULTS_REQUEST", s.GET_RESULTS_REQUEST_DONE = "GET_RESULTS_REQUEST_DONE", s.GET_RESULTS_REQUEST_FAILED = "GET_RESULTS_REQUEST_FAILED", s))(K || {});
const ai = {
  submission: null,
  execution: null,
  analysis: null,
  status: S.INITIAL,
  error: null
}, ii = (s, t) => it(s, (n) => {
  switch (t.type) {
    case K.GET_RESULTS_REQUEST:
    case K.GET_COMBINED_RESULTS:
      n.status = S.IN_PROGRESS;
      break;
    case K.GET_RESULTS_REQUEST_DONE:
      n.submission = t.payload.submission, n.analysis = t.payload.analysis, n.status = S.SUCCESS;
      break;
    case K.GET_COMBINED_RESULTS_DONE:
      n.execution = t.payload.execution, n.analysis = t.payload.analysis, n.status = S.SUCCESS;
      break;
    case K.GET_RESULTS_REQUEST_FAILED:
    case K.GET_COMBINED_RESULTS_ERROR:
      n.error = t.payload, n.status = S.ERROR;
      break;
  }
}), ri = [
  {
    value: v.PENDING,
    title: "Pending"
  },
  {
    value: v.QUEUED,
    title: "Queued"
  },
  {
    value: v.PREPARING,
    title: "Preparing"
  },
  {
    value: v.IN_PROGRESS,
    title: "In progress"
  },
  {
    value: v.FAILED,
    title: "Failed"
  },
  {
    value: v.INITIAL,
    title: "Initial"
  },
  {
    value: v.AWAITING_APPROVAL,
    title: "Awaiting approval"
  },
  {
    value: v.PROCESSING_RESULTS,
    title: "Processing in progress"
  },
  {
    value: v.PROCESSING_RESULTS_FAILED,
    title: "Processing failed"
  },
  {
    value: v.AWAITING_PUBLISHING_APPROVAL,
    title: "Awaiting publishing approval"
  },
  {
    value: v.PUBLISHED,
    title: "Published"
  },
  {
    value: v.DISMISSED,
    title: "Dismissed"
  },
  {
    value: v.CANCELING,
    title: "Canceling"
  },
  {
    value: v.CANCELLED,
    title: "Cancelled"
  }
], oi = (s) => s.toLowerCase().split("_").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" "), Fe = (s) => ri.find((t) => t.value === s) || {
  value: s,
  title: oi(s)
};
ht.START_DATE, ht.END_DATE;
const li = (s) => {
  const { onOpen: t, viewMode: n } = s;
  return /* @__PURE__ */ e.jsx(
    B,
    {
      onClick: t,
      color: "primary",
      size: "small",
      variant: "contained",
      startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "uploadFiles", name: "Execute" }),
      disabled: n,
      children: "Upload files"
    }
  );
};
N.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;
const ci = N.div`
  cursor: pointer;
`;
N.div``;
N.div`
  padding: 12px;
`;
const ui = N.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  span {
    display: inline-block;
    margin-left: 8px;
    position: relative;
    /* top: -4px; */
  }
`;
N.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
`;
N.div`
  display: flex;
  flex-direction: column;
`;
N.div`
  padding: 8px 0;
  align-items: center;
  display: flex;
`;
N.div`
  color: ${({ theme: s }) => {
  var t;
  return (t = s.palette) == null ? void 0 : t.grey[500];
}};
  margin-right: 10px;
`;
N.div`
  //font-size: 16px;
  //text-transform: uppercase;
  font-weight: 500;
`;
N.div``;
N.div`
  border-top: 1px solid ${({ theme: s }) => {
  var t;
  return (t = s.palette) == null ? void 0 : t.borderColor.main;
}};
  width: 100%;
  margin: 16px 0;
`;
N.div`
  margin-bottom: 16px;
  //font-size: 16px;
  font-weight: bold;
`;
N.div`
  cursor: pointer;
  color: ${({ theme: s }) => {
  var t;
  return (t = s.palette) == null ? void 0 : t.primary.main;
}};
`;
const ft = N.div`
  display: flex;
  & > button:first-of-type {
    margin-right: -1px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  & > button:last-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`, we = N(B)`
  min-width: 0;
  padding: 6px;
  svg {
    font-size: 16px;
  }
  button {
    border-radius: 2px;
  }
`, Ze = (s) => {
  if (typeof s != "string")
    return s;
  try {
    return JSON.parse(s);
  } catch {
    return null;
  }
}, bt = {
  minWidth: 0,
  padding: "3px 6px",
  whiteSpace: "nowrap",
  "& .MuiButton-startIcon": {
    marginLeft: 0,
    marginRight: "4px"
  }
}, di = (s, t, n, o, c, l, i, x, h, u, p, r, d, m) => ({
  columns: [
    {
      header: "Data Source",
      accessorKey: "dataSource",
      size: 350,
      minSize: 150,
      enableResizing: !1,
      cell: ({ getValue: g }) => g() ? /* @__PURE__ */ e.jsxs(
        ge,
        {
          sx: {
            display: "inline-flex",
            maxWidth: "100%",
            boxSizing: "border-box",
            "& *:first-child": {
              marginRight: 1
            },
            "& *:last-child": {
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              alignItems: "center"
              // marginRight: 1,
            }
          },
          children: [
            /* @__PURE__ */ e.jsx(Ts, { value: g().id, size: 20 }),
            /* @__PURE__ */ e.jsx(fs, { dataSource: g() })
          ]
        }
      ) : /* @__PURE__ */ e.jsx(e.Fragment, {})
    },
    {
      header: "Status",
      accessorKey: "state",
      size: 130,
      enableResizing: !1,
      cell: ({ getValue: g, row: C }) => {
        const f = g(), { id: E, state: b } = C.original;
        return f ? /* @__PURE__ */ e.jsx(
          ci,
          {
            onClick: () => {
              x(E);
            },
            children: /* @__PURE__ */ e.jsx(
              Nt,
              {
                status: Fe(f)
              }
            )
          }
        ) : /* @__PURE__ */ e.jsx(e.Fragment, {});
      }
    },
    {
      header: "Duration",
      id: "duration",
      accessorFn: (g) => Gs(g),
      size: 130,
      minSize: 130,
      enableResizing: !1
    },
    {
      header: "Execute",
      accessorKey: "state",
      id: "execute",
      size: 70,
      minSize: 70,
      enableResizing: !1,
      cell: ({ getValue: g, row: C }) => {
        const f = g(), E = C.original.actions, b = v.AWAITING_APPROVAL !== f || r[C.original.id], P = E.accept && !b, X = E.dismiss && !b, w = [
          v.PUBLISHED,
          v.IN_PROGRESS,
          v.AWAITING_PUBLISHING_APPROVAL
        ].includes(f), M = v.DISMISSED == f;
        return /* @__PURE__ */ e.jsxs(ft, { children: [
          /* @__PURE__ */ e.jsx(
            we,
            {
              disabled: !w && !P,
              onClick: () => o(C.original.id),
              color: "success",
              size: "small",
              variant: w ? "contained" : "outlined",
              sx: { pointerEvents: w ? "none" : "all" },
              children: r[C.original.id] ? /* @__PURE__ */ e.jsx(W, { size: 16 }) : /* @__PURE__ */ e.jsx(D, { iconName: "submit", name: "Execute" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            we,
            {
              disabled: !M && !X,
              onClick: () => {
                h(c, C.original.id);
              },
              color: "error",
              size: "small",
              variant: M ? "contained" : "outlined",
              sx: { pointerEvents: M ? "none" : "all" },
              children: r[C.original.id] ? /* @__PURE__ */ e.jsx(W, { size: 16 }) : /* @__PURE__ */ e.jsx(D, { iconName: "deactivate", name: "Cancel" })
            }
          )
        ] });
      }
    },
    {
      header: "Publish",
      accessorKey: "state",
      id: "publish",
      size: 70,
      maxSize: 70,
      enableResizing: !1,
      cell: ({ getValue: g, row: C }) => {
        const f = g(), E = C.original.actions, b = v.AWAITING_PUBLISHING_APPROVAL !== f || r[C.original.id], P = E["approve-publish"] && !b, X = E.dismiss && !b, w = v.PUBLISHED === f, M = v.DISMISSED === f;
        return /* @__PURE__ */ e.jsxs(ft, { children: [
          /* @__PURE__ */ e.jsx(
            we,
            {
              disabled: !w && !P,
              onClick: () => l(C.original.id),
              color: "success",
              size: "small",
              sx: { pointerEvents: w ? "none" : "all" },
              variant: w ? "contained" : "outlined",
              children: r[C.original.id] ? /* @__PURE__ */ e.jsx(W, { size: 16 }) : /* @__PURE__ */ e.jsx(D, { iconName: "submit", name: "Execute" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            we,
            {
              disabled: !M && !X,
              onClick: () => {
                h(i, C.original.id);
              },
              color: "error",
              size: "small",
              sx: { pointerEvents: M ? "none" : "all" },
              variant: M ? "contained" : "outlined",
              children: r[C.original.id] ? /* @__PURE__ */ e.jsx(W, { size: 16 }) : /* @__PURE__ */ e.jsx(D, { iconName: "deactivate", name: "Cancel" })
            }
          )
        ] });
      }
    },
    {
      header: "Results",
      accessorKey: "resultInfo",
      size: 92,
      minSize: 84,
      maxSize: 96,
      enableResizing: !1,
      cell: ({ getValue: g, row: C }) => {
        const f = g(), { id: E, state: b, resultFileAmount: P, dataSource: X, summary: w } = C.original, M = C.original.actions, R = M["upload-results"];
        if (M["view-results"] || R) {
          if ([
            v.PROCESSING_RESULTS,
            v.IN_PROGRESS
          ].includes(b))
            return /* @__PURE__ */ e.jsx(e.Fragment, { children: X.executionPolicy === "MANUAL" ? /* @__PURE__ */ e.jsx(
              li,
              {
                viewMode: !R && p,
                onOpen: () => n(E)
              }
            ) : /* @__PURE__ */ e.jsxs(ui, { children: [
              /* @__PURE__ */ e.jsx(W, { size: 18 }),
              /* @__PURE__ */ e.jsxs("span", { children: [
                v.PROCESSING_RESULTS === b ? "Processing..." : "Executing...",
                " "
              ] })
            ] }) });
          if (b === v.FAILED || b === v.AWAITING_PUBLISHING_APPROVAL || b === v.PUBLISHED) {
            if (w)
              return /* @__PURE__ */ e.jsx(
                B,
                {
                  onClick: (Q) => t(Q, E),
                  variant: "contained",
                  size: "small",
                  color: "success",
                  startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "search" }),
                  sx: bt,
                  name: "save",
                  children: w
                }
              );
            const U = Ze(f);
            return /* @__PURE__ */ e.jsx(
              B,
              {
                onClick: (Q) => t(Q, E),
                variant: "contained",
                size: "small",
                color: "success",
                startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "search" }),
                sx: bt,
                name: "save",
                children: U && f && u ? u(U) : `${P} files`
              }
            );
          }
        }
        return /* @__PURE__ */ e.jsx(e.Fragment, { children: "No files" });
      }
    },
    {
      header: "",
      accessorKey: "id",
      id: "cancelCell",
      size: 40,
      minSize: 40,
      maxSize: 40,
      enableResizing: !1,
      enableHiding: !1,
      enableSorting: !1,
      meta: { columnType: "action" },
      cell: ({ row: g }) => {
        const { id: C } = g.original;
        return g.original.actions.cancel && !(m != null && m.has(C)) ? /* @__PURE__ */ e.jsx(tt, { text: "Cancel submission", children: /* @__PURE__ */ e.jsx(
          At,
          {
            color: "error",
            onClick: (b) => {
              b.stopPropagation(), d(C);
            },
            size: "small",
            children: /* @__PURE__ */ e.jsx(D, { iconName: "close", fontSize: "small" })
          }
        ) }) : null;
      }
    }
  ]
}), Vt = (s, t, n = null) => {
  const [o, c] = et(
    ii,
    ai
  ), l = q(async () => {
    c({
      type: K.GET_RESULTS_REQUEST
    });
    try {
      const x = await ke(s), h = await ja(t), u = await (h.resultInfo ?? gt(t));
      c({
        type: K.GET_RESULTS_REQUEST_DONE,
        payload: {
          analysis: x,
          submission: {
            ...h,
            resultInfo: Ze(u)
          }
        }
      });
    } catch (x) {
      c({
        type: K.GET_RESULTS_REQUEST_FAILED,
        payload: x
      });
    }
  }, []), i = q(async () => {
    c({
      type: K.GET_COMBINED_RESULTS
    });
    try {
      const x = await ke(s), h = await Ra(n), u = await Promise.all(
        h.submissions.map(
          (r) => gt(r.id)
        )
      ), p = h.submissions.map(
        (r, d) => ({
          ...r,
          resultInfo: Ze(u[d])
        })
      );
      c({
        type: K.GET_COMBINED_RESULTS_DONE,
        payload: {
          analysis: x,
          execution: {
            ...h,
            submissions: p
          }
        }
      });
    } catch (x) {
      console.error(x), c({
        type: K.GET_COMBINED_RESULTS_ERROR,
        payload: x
      });
    }
  }, []);
  return V(() => {
    n && i(), t && l();
  }, []), {
    ...o
  };
};
N.div`
  padding: 10px;
  margin: 10px 0px;
  background: #ffffff;
`;
const pi = N.div`
  font-size: 14px;
  padding: 5px 5px;
  color: ${({ theme: s }) => {
  var t;
  return (t = s.palette) == null ? void 0 : t.primary.main;
}};
  font-weight: 700;
  border-bottom: 1px solid #e5e5e5;
  label {
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
  }
  span {
    font-size: 10px;
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
    color: #838383;
  }
  &:hover {
    background-color: ${({ theme: s }) => s.palette.backgroundColor.main};
  }
`;
N.div`
  margin: 15px;
  margin-top: 0;
`;
const mi = N.div`
  & > button {
    margin-right: 10px;
  }
`, yi = (s) => {
  const { files: t, onClose: n, batchId: o } = s, c = os(), [l, i] = Y(!1), [x, h] = Y(""), u = () => {
    i(!0), h("");
    try {
      const r = `download-files-${o}`, d = document.createElement("iframe"), m = document.createElement("form");
      d.name = r, d.style.display = "none", m.action = `/api/analyses/batches/${o}/files/download`, m.method = "GET", m.target = r, m.style.display = "none", document.body.appendChild(d), document.body.appendChild(m), m.submit(), document.body.removeChild(m), window.setTimeout(() => {
        i(!1), n();
      }, 1500), window.setTimeout(() => {
        document.body.removeChild(d);
      }, 6e5);
    } catch (r) {
      console.error(r), h("Download failed. Please try again."), i(!1);
    }
  }, p = () => {
    l || n();
  };
  return /* @__PURE__ */ e.jsx(y, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(jt, { elevation: 0, sx: { p: 2 }, children: [
    t.map((r) => {
      var m, g;
      const d = Bs(r.fileMetadata.realName);
      return /* @__PURE__ */ e.jsxs(pi, { children: [
        /* @__PURE__ */ e.jsx(
          D,
          {
            iconName: Ws(d),
            sx: { color: (m = c.palette) == null ? void 0 : m.primary.main }
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: r.fileMetadata.realName }),
        /* @__PURE__ */ e.jsxs("span", { children: [
          "(",
          Hs(r.fileMetadata.length),
          ")"
        ] }),
        /* @__PURE__ */ e.jsx("span", { children: Le((g = r == null ? void 0 : r.modified) == null ? void 0 : g.timestamp) })
      ] });
    }),
    x && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ e.jsx(Ee, { color: "error", variant: "subtitle2", children: x }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ e.jsxs(mi, { children: [
      /* @__PURE__ */ e.jsx(
        B,
        {
          variant: "outlined",
          disabled: l,
          onClick: p,
          startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "close" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ e.jsx(
        B,
        {
          onClick: u,
          variant: "contained",
          color: "success",
          name: "download-executed",
          disabled: l,
          startIcon: l ? /* @__PURE__ */ e.jsx(W, { size: 16 }) : /* @__PURE__ */ e.jsx(D, { iconName: "submit" }),
          children: l ? "Starting download..." : "Download all files"
        }
      )
    ] }) })
  ] }) }) });
}, xi = N.div`
  font-size: 14px;
  font-weight: 700;
`, It = N.div`
  font-size: 12px;
  label {
    color: ${({ theme: s }) => {
  var t;
  return (t = s.palette) == null ? void 0 : t.primary.main;
}};
    font-weight: 700;
    font-size: 12px;
    margin-top: 10px;
  }
  span {
    font-weight: 500;
  }
`, hi = N.div`
  margin-top: 0px;
  font-size: 12px;
  label {
    color: ${({ theme: s }) => {
  var t;
  return (t = s.palette) == null ? void 0 : t.primary.main;
}};
    font-weight: 700;
    font-size: 12px;
    margin-top: 10px;
  }
  span {
    font-weight: 700;
  }
  button {
    // padding: 0 10px;
    // margin-top: -3px;
  }
`, Ei = N.div`
  padding: 20px;
  background: #ffffff;
  border: 1px dotted ${({ theme: s }) => {
  var t;
  return (t = s.palette) == null ? void 0 : t.borderColor.main;
}};
  border-radius: 4px;
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
  margin-bottom: 8px;
`, Si = (s) => {
  var p;
  const { execution: t, columns: n, analysisType: o } = s, c = me(), { openModal: l, closeModal: i } = Z(_e), x = o === T.FEASIBILITY && t.submissions.some(
    (r) => r.state === v.AWAITING_PUBLISHING_APPROVAL || r.state === v.PUBLISHED
  ), h = () => {
    var r;
    l(
      () => /* @__PURE__ */ e.jsx(
        yi,
        {
          files: t.executableFiles,
          batchId: t.id,
          analysisId: t.analysis.id,
          modified: t.modified,
          onClose: i,
          onChange: () => {
          }
        }
      ),
      /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        "Download Files",
        /* @__PURE__ */ e.jsx(Ee, { variant: "subtitle2", component: "div", children: Le((r = t == null ? void 0 : t.modified) == null ? void 0 : r.timestamp) }),
        /* @__PURE__ */ e.jsx("div", {})
      ] }),
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, u = () => {
    c("execution/" + t.id);
  };
  return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, component: "tbody", children: /* @__PURE__ */ e.jsx("tr", { children: /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsxs(Ei, { children: [
    /* @__PURE__ */ e.jsxs(
      y,
      {
        container: !0,
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1,
        mt: -1,
        children: [
          /* @__PURE__ */ e.jsx(y, { item: !0, minWidth: 140, children: /* @__PURE__ */ e.jsx(xi, { children: `Execution #${parseInt(t.shortcut) + 1}` }) }),
          x && /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
            B,
            {
              variant: "contained",
              color: "success",
              onClick: u,
              size: "small",
              startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "list", fontSize: "large" }),
              children: "Results summary"
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(
      ge,
      {
        sx: {
          width: "100%",
          maxWidth: "100%",
          overflowX: "auto",
          pb: 0.5,
          "& > .MuiBox-root": {
            minWidth: 890
          },
          "& .divTable": {
            minWidth: "100%"
          },
          '& [class*="table-cell-resultInfo"]': {
            paddingLeft: "3px",
            paddingRight: "3px"
          },
          '& [class*="table-cell-resultInfo"] .cell-wrapper': {
            display: "inline-flex",
            width: "fit-content",
            minWidth: "fit-content",
            maxWidth: "fit-content"
          },
          '& [class*="table-header-cell-cancelCell"], & [class*="table-cell-cancelCell"]': {
            width: "1px !important",
            whiteSpace: "nowrap"
          }
        },
        children: /* @__PURE__ */ e.jsxs(ge, { children: [
          /* @__PURE__ */ e.jsx(st, {}),
          /* @__PURE__ */ e.jsx(
            vt,
            {
              data: t.submissions,
              columns: n,
              pageSize: (p = t.submissions) == null ? void 0 : p.length,
              hideSettings: !0,
              hidePagination: !0
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ e.jsxs(y, { container: !0, columnSpacing: 2, alignItems: "center", mt: 1, children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, children: t.checksum && /* @__PURE__ */ e.jsxs(It, { children: [
        /* @__PURE__ */ e.jsx("label", { children: "Checksum: " }),
        /* @__PURE__ */ e.jsx(
          Ee,
          {
            variant: "subtitle2",
            component: "span",
            sx: { color: "#0d1b40" },
            children: t.checksum.toString(16) || "-"
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsxs(It, { children: [
        /* @__PURE__ */ e.jsx("label", { children: "Created at: " }),
        /* @__PURE__ */ e.jsx("span", { children: Le(t.created.timestamp) })
      ] }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsxs(hi, { children: [
        /* @__PURE__ */ e.jsx("label", { children: "Submitted files:" }),
        /* @__PURE__ */ e.jsxs(
          B,
          {
            onClick: h,
            variant: "text",
            size: "small",
            startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "import" }),
            sx: {
              textDecoration: "underline",
              fontSize: "12px",
              ml: 1
            },
            children: [
              t.executableFiles && t.executableFiles.length,
              " ",
              "files to download"
            ]
          }
        )
      ] }) })
    ] })
  ] }) }) }) });
}, gi = N.div`
  margin-top: 20px;
  & > button {
    margin-right: 10px;
  }
`, Ci = N.div`
  border-bottom: 1px solid
    ${({ theme: s }) => s.palette.borderColor.light};
  &:hover {
    background-color: ${({ theme: s }) => s.palette.backgroundColor.main};
  }
  span {
    display: block;
    font-size: 12px;
    text-align: right;
  }
  p {
    font-size: 12px;
    text-align: right;
    font-weight: 700;
    margin: 0;
    margin-top: 4px;
  }
`, Ti = Te((s) => {
  const { onCancel: t, id: n } = s, [o, c] = Y([]);
  return V(() => {
    Da(n).then((l) => {
      c(l);
    });
  }, []), /* @__PURE__ */ e.jsx(Se, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, p: 2, children: [
    o.map((l) => {
      var i, x;
      return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ci, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, p: 0.5, alignItems: "center", children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 7, children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
          /* @__PURE__ */ e.jsx(ge, { component: "span", sx: { marginRight: "5px" }, children: /* @__PURE__ */ e.jsx(
            Nt,
            {
              status: Fe(l.data.state)
            }
          ) }),
          ((i = l == null ? void 0 : l.data) == null ? void 0 : i.dismissNote) && /* @__PURE__ */ e.jsx(
            tt,
            {
              text: ((x = l == null ? void 0 : l.data) == null ? void 0 : x.dismissNote) || "",
              color: "primary",
              width: 150,
              children: /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsx(
                D,
                {
                  iconName: "chatBubble",
                  sx: { color: "gray" }
                }
              ) })
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 5, children: [
          /* @__PURE__ */ e.jsx("span", { children: Ys(l.user) }),
          /* @__PURE__ */ e.jsx("p", { children: Le(l.timestamp) })
        ] })
      ] }) }) });
    }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(gi, { children: /* @__PURE__ */ e.jsx(
      B,
      {
        variant: "outlined",
        onClick: t,
        size: "small",
        startIcon: /* @__PURE__ */ e.jsx(D, { iconName: "close" }),
        children: "Close"
      }
    ) }) })
  ] }) });
}), fi = (s) => {
  const {
    studyId: t,
    analysisId: n,
    path: o,
    updateRequest: c,
    rootPath: l,
    type: i,
    resultFormater: x,
    viewMode: h,
    executionCount: u
  } = s, p = me(), { openModal: r, closeModal: d } = Z(_e), { showDialog: m, hideDialog: g } = Z(kt), { subModules: C } = Z(
    be
  ), {
    getExecutions: f,
    executions: {
      pageCount: E,
      pageSize: b,
      pageNumber: P,
      totalElements: X,
      data: w
    },
    filters: { data: M, form: R },
    progressExecutionIds: L,
    status: U,
    submissionApprove: Q,
    submissionDismiss: ne,
    submissionApprovePublish: ae,
    submissionDismissPublish: ye,
    submissionCancel: ue,
    cancelledIds: oe,
    updateFilters: de
  } = ni(n);
  _s(() => {
    U !== S.INITIAL && U !== S.IN_PROGRESS && U !== S.IN_PROGRESS_RELOAD && f();
  }, 1e4), V(() => {
    u && f();
  }, [u]);
  const A = q(
    (_, $) => {
      _.preventDefault(), _.stopPropagation(), p(`submission/${$}`);
    },
    [p]
  ), le = (_) => {
    r(
      () => /* @__PURE__ */ e.jsx(Ti, { id: _, onCancel: d }),
      "History",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: d
      }
    );
  }, xe = (_) => {
    m(De, {
      onSubmit: () => {
        ue(_);
      },
      onClose: g,
      text: "Are you sure you want to cancel this submission?",
      confirmButtonText: "CANCEL SUBMISSION",
      variant: "error"
    });
  }, a = (_, $) => {
    m(De, {
      onSubmit: ({ dismissNote: ie }) => {
        _($, {
          note: ie
        });
      },
      onClose: g,
      text: "Enter the reason for the refusal:",
      confirmButtonText: "REJECT",
      TextField: (ie) => /* @__PURE__ */ e.jsx(ge, { sx: { minWidth: "300px" }, children: /* @__PURE__ */ ns(Ae, { ...ie, multiline: !0, key: $ }) })
    });
  }, I = (_) => {
    r(
      () => /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(Se, { children: /* @__PURE__ */ e.jsx(
        C.documents,
        {
          type: "component",
          name: "upload-new-document",
          subModules: C,
          config: {
            onChange: () => {
              f(), d();
            },
            onClose: d,
            createMethod: ($) => wa(_, $),
            textAvailableExt: ".ZIP",
            acceptExt: [
              "application/zip",
              "application/octet-stream",
              "application/x-zip-compressed",
              "multipart/x-zip"
            ]
          }
        }
      ) }) }),
      "Upload files",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: d
      }
    );
  }, O = G(
    () => di(
      i,
      A,
      I,
      Q,
      ne,
      ae,
      ye,
      le,
      a,
      x,
      h,
      L,
      xe,
      oe
    ).columns,
    [
      A,
      Q,
      ne,
      ae,
      ye,
      xe,
      oe,
      L
    ]
  ), z = G(
    () => Object.values(R || {}).some(
      (_) => Array.isArray(_) ? _.some(Boolean) : !!_
    ),
    [R]
  );
  return V(() => {
    c && f();
  }, [c]), /* @__PURE__ */ e.jsxs(Qe, { children: [
    /* @__PURE__ */ e.jsx(Se, { outlined: !0, elevated: !0, children: /* @__PURE__ */ e.jsx(y, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(
      y,
      {
        item: !0,
        xs: 12,
        minHeight: 200,
        sx: {
          ".execustions-table > .thead": {
            display: "none"
          }
        },
        children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          vt,
          {
            data: w,
            variant: "controlled",
            columns: [{ header: "", accessorKey: "id" }],
            className: "execustions-table",
            customTableRow: ({ data: _ }) => /* @__PURE__ */ e.jsx(
              Si,
              {
                execution: _,
                columns: O,
                analysisType: i
              }
            ),
            pageCount: E,
            pageSize: b,
            pageIndex: P,
            totalElements: X,
            fetchData: f,
            loading: [S.INITIAL, S.IN_PROGRESS].includes(U),
            showFilterToggle: !0,
            hideTableOptions: !0,
            filtersDefaultClosed: !0,
            hasFilters: z,
            searchComponent: /* @__PURE__ */ e.jsx(y, { container: !0, justifyContent: "flex-end", children: /* @__PURE__ */ e.jsx(
              At,
              {
                size: "small",
                onClick: () => {
                  f();
                },
                name: "reload",
                disabled: U === S.IN_PROGRESS_RELOAD,
                children: U === S.IN_PROGRESS_RELOAD ? /* @__PURE__ */ e.jsx(W, { size: 14 }) : /* @__PURE__ */ e.jsx(tt, { text: "Reload executions", children: /* @__PURE__ */ e.jsx(D, { iconName: "reload", sx: { fontSize: 16 } }) })
              }
            ) }),
            children: /* @__PURE__ */ e.jsx(
              ls,
              {
                showLabel: !0,
                filters: M,
                value: R,
                onChange: de,
                isLoading: U === S.IN_PROGRESS,
                isReloading: U === S.IN_PROGRESS_RELOAD,
                placeholderSize: 2
              }
            )
          }
        ) })
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(ws, {})
  ] });
}, bi = N.div`
  text-align: center;
  font-size: 24px;
  margin-top: 50px;
  margin-bottom: 50px;
  color: lightgrey;
`, Ii = Te((s) => {
  const { resultInfo: t, analysisInfo: n, analysesTypes: o, subModules: c } = s, { results: l } = G(
    () => o[n == null ? void 0 : n.type],
    [n == null ? void 0 : n.type]
  ), i = q(() => /* @__PURE__ */ e.jsx(
    l,
    {
      data: t,
      analysisInfo: n,
      subModules: c
    }
  ), [n == null ? void 0 : n.type]);
  if (![
    T.COHORT,
    T.INCIDENCE,
    T.COHORT_PATHWAY,
    T.COHORT_CHARACTERIZATION,
    T.SIMPLE_COUNTS_CHARACTERIZATION,
    T.BULK_COHORT_COUNTS,
    T.DATACUT,
    T.FEASIBILITY,
    T.TIME_TO_EVENT,
    T.COST
  ].includes(n == null ? void 0 : n.type))
    return /* @__PURE__ */ e.jsx(fe, { children: /* @__PURE__ */ e.jsx(bi, { children: "View raw results in the Files tab" }) });
  const x = [
    T.INCIDENCE,
    T.FEASIBILITY,
    T.TIME_TO_EVENT,
    T.COST
  ].includes(n == null ? void 0 : n.type);
  return /* @__PURE__ */ e.jsx(y, { container: !0, children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: x ? /* @__PURE__ */ e.jsx(y, { container: !0, children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: i() }) }) : /* @__PURE__ */ e.jsx(Se, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(y, { container: !0, children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: i() }) }) }) }) });
}), Qt = (s, t, n) => {
  const o = [], {
    rootTitle: c,
    parentTitle: l,
    title: i,
    rootPath: x,
    parentId: h,
    path: u,
    currentId: p,
    currentTitle: r
  } = n;
  return c && (o[0] = {
    name: c,
    path: `${x}`
  }), h && (o[1] = {
    name: l,
    path: `${x}/${h}`
  }), c !== i ? h ? (o[2] = {
    name: i,
    path: u
  }, o[3] = {
    name: r,
    path: `${u}/${p}`
  }, o[4] = {
    name: t,
    path: `${u}/${s}`
  }) : (o[1] = {
    name: i,
    path: u
  }, o[2] = {
    name: r,
    path: `${u}/${p}`
  }, o[3] = {
    name: t,
    path: `${u}/${s}`
  }) : (o[2] = {
    name: r,
    path: `${u}/${p}`
  }, o[3] = {
    name: t,
    path: `${u}/${s}`
  }), o;
}, Ri = (s) => s ? [
  {
    title: "Analysis results",
    value: "",
    end: !0
  },
  {
    title: "Files",
    value: "files"
  }
] : [
  {
    title: "Files",
    value: ""
  }
], qt = () => {
  const s = $e(), { id: t, submissionId: n } = at(), { rootSettings: o, path: c, title: l, config: i, analysesTypes: x, subModules: h } = Z(
    be
  ), u = me(), { submission: p, analysis: r, status: d } = Vt(t, n), m = (p == null ? void 0 : p.resultInfo) != null, g = G(() => Ri(m), [m]), { rootPath: C, rootTitle: f } = o, { parentId: E, parentTitle: b } = i;
  return V(() => {
    s(
      rt(
        Qt(n, "Results", {
          path: c,
          title: l,
          rootPath: C,
          rootTitle: f,
          parentTitle: b,
          parentId: E,
          currentId: t,
          currentTitle: r == null ? void 0 : r.title
        })
      )
    );
  }, [c, r]), [S.INITIAL, S.IN_PROGRESS].includes(d) ? /* @__PURE__ */ e.jsx(fe, { children: /* @__PURE__ */ e.jsx(W, { size: 32 }) }) : /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsxs(Ot, { children: [
      /* @__PURE__ */ e.jsx(
        Pt,
        {
          entity: r,
          submission: {
            ...p,
            status: Fe(p.state)
          },
          AnalysisIcon: /* @__PURE__ */ e.jsx(ze, { value: r.type, size: 32 })
        }
      ),
      /* @__PURE__ */ e.jsx(st, {}),
      /* @__PURE__ */ e.jsx(wt, { tabs: g, withRouting: !0, secondary: !0 })
    ] }),
    /* @__PURE__ */ e.jsxs(Dt, { fallBack: /* @__PURE__ */ e.jsx(e.Fragment, { children: "Something went wrong" }), children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, py: 2, px: 6, children: p.resultInfoError === "USER_HAS_NO_ACCESS_TO_SUBMISSION_RESULTS" ? /* @__PURE__ */ e.jsx(
        qe,
        {
          statusText: "Permission denied. If the problem persists, please contact the data source owner.",
          status: 403,
          message: "Submission status: " + Fe(p.state).title,
          data: void 0,
          path: c + "/" + r.id + "/executions"
        }
      ) : /* @__PURE__ */ e.jsxs(Ce, { children: [
        m && /* @__PURE__ */ e.jsx(
          H,
          {
            path: "*",
            element: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                Ii,
                {
                  analysesTypes: x,
                  analysisInfo: r,
                  resultInfo: r.type === T.FEASIBILITY ? { submissions: [p] } : p.resultInfo,
                  subModules: h
                }
              ),
              /* @__PURE__ */ e.jsx(Ce, { children: /* @__PURE__ */ e.jsx(
                H,
                {
                  path: "modal/related/:conceptId",
                  element: /* @__PURE__ */ e.jsx(
                    Ve,
                    {
                      open: !0,
                      onClose: () => {
                        u("");
                      },
                      children: /* @__PURE__ */ e.jsx(
                        h.vocabulary,
                        {
                          type: "component",
                          name: "vocabulary-concept",
                          subModules: h,
                          config: {
                            onClose: () => {
                              u("");
                            },
                            viewMode: !0,
                            vocabularyMode: !1
                          },
                          canEdit: !1,
                          path: `${c}/${t}/submissions/${n}`
                        }
                      )
                    }
                  )
                }
              ) })
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(
          H,
          {
            path: m ? "files" : "",
            element: /* @__PURE__ */ e.jsx(
              Lt,
              {
                submissionId: n,
                url: "submissions"
              }
            )
          }
        )
      ] }) }),
      " "
    ] })
  ] });
}, ji = Te((s) => {
  const { id: t } = s, { exportAnalysis: n } = Ns(Qs.ANALYSIS, t), o = G(
    () => n == null ? void 0 : n.title,
    [n == null ? void 0 : n.title]
  ), c = G(
    () => Ft(Ue.JSON),
    []
  );
  return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, p: 2, children: n && /* @__PURE__ */ e.jsx(
    _t,
    {
      data: n,
      fileName: o,
      language: c,
      readOnly: !0,
      fileExtension: Ue.JSON
    }
  ) });
}), Ai = () => {
  const s = $e(), { id: t, executionId: n } = at(), { rootSettings: o, path: c, title: l, config: i, analysesTypes: x, subModules: h } = Z(
    be
  ), { execution: u, analysis: p, status: r } = Vt(t, null, n), { results: d } = G(
    () => x[p == null ? void 0 : p.type] || {},
    [p == null ? void 0 : p.type, x]
  ), m = q(() => {
    switch (r) {
      case S.SUCCESS:
        return /* @__PURE__ */ e.jsx(
          d,
          {
            data: u,
            analysisInfo: p,
            subModules: h
          }
        );
      case S.IN_PROGRESS:
      case S.INITIAL:
        return /* @__PURE__ */ e.jsx(ge, { textAlign: "center", children: /* @__PURE__ */ e.jsx(W, {}) });
      case S.ERROR:
        return "";
    }
  }, [p == null ? void 0 : p.type]), { rootPath: g, rootTitle: C } = o, { parentId: f, parentTitle: E } = i;
  return V(() => {
    s(
      rt(
        Qt(n, "Results", {
          path: c,
          title: l,
          rootPath: g,
          rootTitle: C,
          parentTitle: E,
          parentId: f,
          currentId: t,
          currentTitle: p == null ? void 0 : p.title
        })
      )
    );
  }, [c, p]), [S.INITIAL, S.IN_PROGRESS].includes(r) ? /* @__PURE__ */ e.jsx(fe, { children: /* @__PURE__ */ e.jsx(W, { size: 32 }) }) : /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(Ot, { children: /* @__PURE__ */ e.jsx(
      Pt,
      {
        entity: p,
        AnalysisIcon: /* @__PURE__ */ e.jsx(ze, { value: p.type, size: 32 })
      }
    ) }),
    /* @__PURE__ */ e.jsx(Dt, { fallBack: /* @__PURE__ */ e.jsx(e.Fragment, { children: "Something went wrong" }), children: /* @__PURE__ */ e.jsxs(Ce, { children: [
      /* @__PURE__ */ e.jsx(
        H,
        {
          path: "*",
          element: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, py: 2, px: 6, children: m() })
        }
      ),
      /* @__PURE__ */ e.jsx(
        H,
        {
          path: "files",
          element: /* @__PURE__ */ e.jsx(
            y,
            {
              container: !0,
              spacing: 2,
              px: 4,
              py: 2,
              sx: {
                ".collapsible-block__content-container": {
                  p: 0
                }
              },
              children: u.submissions.map((b) => /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                cs,
                {
                  collapsible: !0,
                  title: b.dataSource.name,
                  outlined: !0,
                  defaultState: !1,
                  children: /* @__PURE__ */ e.jsx(
                    Lt,
                    {
                      submissionId: b.id,
                      url: "submissions"
                    }
                  )
                }
              ) }))
            }
          )
        }
      )
    ] }) })
  ] });
}, vi = () => {
  var pt, mt, yt;
  const s = me(), { id: t } = at(), n = $e(), { showDialog: o, hideDialog: c } = Z(kt), l = xt(
    "study-manager/:id/analyses/:id/submissions/:submissionId/*",
    location.pathname
  ), i = xt(
    "workspace/analyses/:id/submissions/:submissionId/*",
    location.pathname
  ), { openModal: x, closeModal: h } = Z(_e), [u, p] = Y(0), { rootSettings: r, path: d, title: m, config: g, subModules: C, analysesTypes: f } = Z(be), { rootPath: E, rootTitle: b } = r, { parentId: P, parentTitle: X, typeContainer: w } = g, { entityBreadcrumbs: M, apiMethodsVersioning: R } = Ja, L = G(() => Xa(w, P), [P]), {
    status: U,
    summary: Q,
    component: ne,
    conceptSetAttr: ae,
    formatDesign: ye,
    atlasEntity: ue,
    designStatus: oe,
    isVersionMode: de,
    entity: A,
    error: le,
    updateEntity: xe,
    design: a,
    updateDesign: I,
    isEqual: O,
    reloadDesign: z,
    setVersionEntity: _,
    revertEntity: $,
    deleteEntity: ie,
    copyEntity: pe,
    outdatedCohortReferences: k,
    saveDesign: se,
    getCountsSummary: re,
    updateDesignBase: Ge,
    permissions: Be,
    actions: Oe
  } = Os(L, t, "Analysis", f, za), he = G(() => {
    switch (w) {
      case J.WORKSPACE:
        return !1;
      case J.STUDY:
        return !(Oe != null && Oe[Ps.UPDATE]);
      default:
        return !0;
    }
  }, [Oe, w]), ut = G(
    () => ({
      ...Q,
      batches: Math.max((Q == null ? void 0 : Q.batches) || 0, u)
    }),
    [u, Q]
  ), Xt = G(() => {
    var F, ce;
    return Ka(
      (F = f[A == null ? void 0 : A.type]) == null ? void 0 : F.localConceptSet,
      (ce = a == null ? void 0 : a.design) == null ? void 0 : ce[ae],
      he,
      ut
    );
  }, [A, ut, a, he]), Kt = () => {
    o(De, {
      onSubmit: async () => {
        try {
          await ie(), s(`/${d}`);
        } catch {
        }
      },
      onClose: c,
      text: "Are you sure you want to delete this analysis?",
      confirmButtonText: "DELETE",
      variant: "error"
    });
  };
  V(() => {
    A && !l && !i && n(
      rt(
        M(t, A == null ? void 0 : A.title, {
          path: d,
          title: m,
          rootPath: E,
          rootTitle: b,
          parentTitle: X,
          parentId: P
        })
      )
    );
  }, [d, A, l, i]), V(() => {
    document.title = "Prometheus - " + b + " - Analyses";
  }, [b]);
  const We = (F) => {
    const ce = (k == null ? void 0 : k.length) || 0;
    ce ? o(De, {
      onSubmit: F,
      onClose: c,
      text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        "Newer versions exist for",
        /* @__PURE__ */ e.jsxs("b", { children: [
          " ",
          k.map((ss) => ss.name).join(", "),
          " "
        ] }),
        "cohort",
        ce > 1 ? "s" : "",
        ", do you want to",
        " ",
        /* @__PURE__ */ e.jsx("b", { children: "continue without refreshing" }),
        " them?"
      ] }),
      cancelButtonText: "Return to Analysis",
      confirmButtonText: "Continue",
      variant: "info"
    }) : F();
  }, Jt = () => {
    x(
      () => /* @__PURE__ */ e.jsx(
        Za,
        {
          subModules: C,
          typeContainer: w,
          parentId: P,
          analysisId: t,
          afterCreate: async () => {
            p((F) => F + 1), await re(), h(), s("executions");
          },
          type: A.type,
          onClose: h
        }
      ),
      "Create submit request",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: h
      }
    );
  }, dt = G(
    () => {
      var F, ce;
      return (a == null ? void 0 : a.type) === T.COHORT_PATHWAY && (((F = a == null ? void 0 : a.design) == null ? void 0 : F.analysisType) === "pre-index" || ((ce = a == null ? void 0 : a.design) == null ? void 0 : ce.includePreIndexEvents) === !0);
    },
    [
      a == null ? void 0 : a.type,
      (pt = a == null ? void 0 : a.design) == null ? void 0 : pt.analysisType,
      (mt = a == null ? void 0 : a.design) == null ? void 0 : mt.includePreIndexEvents
    ]
  ), Zt = dt ? 'Warning! Atlas does not support "Include pre-index events", which is used in this analysis design. The attribute will be removed from the design in target Atlas instance. Depending on data, you might get different results for this analysis in Atlas.' : null, es = dt ? 'Warning! This design uses "Include pre-index events" option. If your target system is Atlas, please be aware that these attributes are not supported by Atlas. The attributes will be removed from the design in target Atlas instance. Depending on data, you might get different results for this analysis in Atlas.' : null, ts = () => {
    x(
      () => /* @__PURE__ */ e.jsx(
        As,
        {
          id: A.id,
          name: a.title,
          parentId: P,
          currentContainer: w,
          subModules: C,
          createCopyMethod: ei,
          entityAtlas: ue,
          typeEntity: "analyses",
          analysisType: a.type,
          onChange: () => {
            h();
          },
          exportJson: /* @__PURE__ */ e.jsx(ji, { id: A.id }),
          exportAtlasWarning: Zt,
          exportJsonWarning: es
        }
      ),
      "Export analysis",
      {
        closeOnClickOutside: !0,
        onClose: h
      }
    );
  };
  return U === S.ERROR ? /* @__PURE__ */ e.jsx(fe, { children: /* @__PURE__ */ e.jsx(qe, { ...(le == null ? void 0 : le.response) ?? {}, path: d }) }) : U === S.INITIAL || U === S.IN_PROGRESS ? /* @__PURE__ */ e.jsx(bs, { children: /* @__PURE__ */ e.jsx(W, { size: 62 }) }) : /* @__PURE__ */ e.jsx(y, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Is, { children: /* @__PURE__ */ e.jsx(
      Rs,
      {
        entity: de ? a : a || A,
        AnalysisIcon: /* @__PURE__ */ e.jsx(ze, { value: A == null ? void 0 : A.type, size: 32 }),
        onDelete: Kt,
        onExport: () => We(ts),
        onSubmit: (F) => {
          se({
            ...a,
            title: F.title,
            description: F.description
          }), re();
        },
        onChange: (F) => {
          Ge({
            title: F.title,
            description: F.description
          });
        },
        onAnalysisSubmit: () => We(Jt),
        disableSave: U !== S.SUCCESS && oe !== S.SUCCESS || Be.disableSave,
        canExecute: Be.canExecute,
        executionMessages: Be.executionMessages,
        onSave: async () => {
          await Promise.allSettled([
            se(a),
            re()
          ]);
        },
        onCopy: () => {
          We(async () => {
            const F = await pe(a);
            s(`/${d}/${F.id}`);
          }), re();
        },
        versionPreview: de,
        onVersionRevert: $,
        onVersionSave: () => {
          se({
            ...A,
            design: a.design,
            title: a.originName
          }), re();
        },
        viewMode: he
      }
    ) }),
    /* @__PURE__ */ e.jsx(e.Fragment, { children: oe === S.SUCCESS && /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
      /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
        /* @__PURE__ */ e.jsx(wt, { tabs: Xt, withRouting: !0, secondary: !0 }),
        /* @__PURE__ */ e.jsx(st, {})
      ] }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, py: 3, children: /* @__PURE__ */ e.jsxs(Ce, { children: [
        /* @__PURE__ */ e.jsx(
          H,
          {
            index: !0,
            element: /* @__PURE__ */ e.jsx(Qe, { children: ne ? /* @__PURE__ */ e.jsx(
              ne,
              {
                id: A.id,
                parentId: P,
                design: a.design,
                subModules: C,
                analysisName: a.title,
                typeContainer: w,
                updateDesign: I,
                reloadDesign: z,
                viewMode: he,
                originalEntity: A
              }
            ) : /* @__PURE__ */ e.jsx(
              qe,
              {
                statusText: "Analysis of this type was not found",
                status: 404,
                message: "",
                data: void 0,
                path: ""
              }
            ) })
          }
        ),
        /* @__PURE__ */ e.jsx(
          H,
          {
            path: "concept-sets/*",
            element: /* @__PURE__ */ e.jsx(
              C.concept,
              {
                type: "component",
                name: "concept-set-sections-widget-new",
                subModules: C,
                config: {
                  onChange: (F) => {
                    I(ae, F);
                  },
                  conceptSets: ((yt = a.design) == null ? void 0 : yt[ae]) || [],
                  viewMode: he,
                  parentId: P,
                  typeContainer: w,
                  analysisMode: !0
                }
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(
          H,
          {
            path: "versions",
            element: /* @__PURE__ */ e.jsx(Qe, { children: /* @__PURE__ */ e.jsx(
              js,
              {
                data: A,
                path: d,
                makeCopy: pe,
                setPreviewEntity: _,
                apiMethods: R,
                originVersionId: A == null ? void 0 : A.versionId
              }
            ) })
          }
        ),
        /* @__PURE__ */ e.jsx(H, { path: "executions/*", children: /* @__PURE__ */ e.jsxs(
          H,
          {
            path: "*",
            element: /* @__PURE__ */ e.jsx(
              fi,
              {
                path: d,
                analysisId: A.id,
                studyId: P,
                updateRequest: !1,
                rootPath: E,
                type: A.type,
                resultFormater: ye,
                viewMode: he,
                executionCount: u
              }
            ),
            children: [
              /* @__PURE__ */ e.jsx(
                H,
                {
                  path: "execution/:executionId/*",
                  element: /* @__PURE__ */ e.jsx(
                    Ve,
                    {
                      width: "95%",
                      open: !0,
                      onClose: () => {
                        s("executions");
                      },
                      children: /* @__PURE__ */ e.jsx(Ai, {})
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx(
                H,
                {
                  path: "submission/:submissionId/*",
                  element: /* @__PURE__ */ e.jsx(
                    Ve,
                    {
                      width: "95%",
                      open: !0,
                      onClose: () => {
                        s("executions");
                      },
                      children: /* @__PURE__ */ e.jsx(qt, {})
                    }
                  )
                }
              )
            ]
          }
        ) })
      ] }) })
    ] }) })
  ] }) });
}, be = as(null), _i = (s) => {
  const { path: t, title: n, name: o, rootSettings: c, initStorage: l, viewMode: i } = s, [x, h] = Y(c), [u, p] = Y(!0), r = zt((g) => g.user), { analyses: d, status: m } = Ut({
    preloadAnalysisTypes: s.config.analysisTypes,
    analyses: Ht,
    tenantId: r.data.activeTenant
  });
  return V(() => {
    c || h({
      rootPath: t,
      rootTitle: n
    }), p(!1);
  }, []), u || [S.INITIAL, S.IN_PROGRESS].includes(m) ? /* @__PURE__ */ e.jsx(fe, { children: /* @__PURE__ */ e.jsx(W, { size: 32 }) }) : /* @__PURE__ */ e.jsx(
    be.Provider,
    {
      value: {
        ...s,
        rootSettings: x,
        analysesTypes: d
      },
      children: /* @__PURE__ */ e.jsxs(Ce, { children: [
        /* @__PURE__ */ e.jsx(
          H,
          {
            path: ":id/*",
            element: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(vi, {}),
              /* @__PURE__ */ e.jsx(Ce, { children: /* @__PURE__ */ e.jsx(
                H,
                {
                  path: "submissions/:submissionId/*",
                  element: /* @__PURE__ */ e.jsx(qt, {})
                }
              ) })
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(H, { index: !0, element: /* @__PURE__ */ e.jsx(Qa, { viewMode: i }) })
      ] })
    }
  );
}, Gi = (s) => {
  const { type: t } = s;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    !t && /* @__PURE__ */ e.jsx(_i, { ...s }),
    t === "component" && /* @__PURE__ */ e.jsx(Ya, { ...s })
  ] });
};
export {
  Gi as Analyses
};
//# sourceMappingURL=analyses.js.map
